import React, { useEffect } from 'react';
import { useLocation, matchPath } from 'react-router-dom';
import { useIntercom } from 'react-use-intercom';
import { useFeatureToggle, useApplicationContext } from '@css-xp/base';
import { INTERCOM_EVENTS, routePaths, STATSIG_FEATURE_GATES } from '@css-xp/ppc-constants';

const ALLOWED_PATHS = [routePaths.customerAddressDetailsByCompany, routePaths.customerAddressDetailsById];

export const IntercomBoot = ({ children }: { children: JSX.Element | JSX.Element[] }) => {
  const { displayName, email, atlassianAccountId, intercomUserHash } = useApplicationContext();
  const { boot, shutdown, trackEvent } = useIntercom();
  const [isEnabled] = useFeatureToggle();
  const location = useLocation();

  const isIntercomEnabled = isEnabled(STATSIG_FEATURE_GATES.ENABLE_INTERCOM_MESSENGER);
  const isEmailPropEnabled = isEnabled(STATSIG_FEATURE_GATES.ENABLE_EMAIL_PROP_INTERCOM);

  useEffect(() => {
    if (isIntercomEnabled && ALLOWED_PATHS.some((path) => matchPath(location.pathname, { path, exact: true }))) {
      boot({
        name: displayName,
        userId: atlassianAccountId,
        userHash: intercomUserHash,
        ...(isEmailPropEnabled ? { email } : {}),
        // avatar: {
        //   type: 'avatar',
        //   imageUrl: picture,
        // },
      });
      trackEvent(INTERCOM_EVENTS.BOOT);
    } else {
      trackEvent(INTERCOM_EVENTS.SHUTDOWN);
      shutdown();
    }
  }, [location.pathname]);

  return <>{children}</>;
};
